import {Component, OnInit} from '@angular/core';
import {
	ModalOptionsConfig,
	ModalService
} from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import {NzModalRef} from 'ng-zorro-antd/modal';
import {
	PasswordRecoveryMessageComponent
} from '../../../../../mobile-modals/password-recovery-message/password-recovery-message.component';

@Component({
	selector: 'app-success-recovery',
	templateUrl: './success-recovery.component.html',
	styleUrls: ['./success-recovery.component.scss']
})
export class SuccessRecoveryComponent implements OnInit {
	runningModal: NzModalRef;

	constructor(private modalService: ModalService) {
	}

	ngOnInit(): void {
		this.launchModal(null, PasswordRecoveryMessageComponent);
	}

	launchModal(params, component) {
		const config = this.createModalConfig(params);
		this.runningModal = this.modalService.createModal(component, config);
	}

	createModalConfig(params) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.data = params;
		config.className = 'moniepoint-dialog';
		config.nzComponentParams.callback = result => {
			this.handleOncloseModal(result);
		};
		return config;
	}

	handleOncloseModal(params) {
		this.runningModal.destroy();
	}

}
